module.exports = __webpack_public_path__ + "img/P4.5bb5e11e.png";